export const API_BASE_URL =
  import.meta.env.VITE_API_URL || "http://localhost:8000/api/v1";
export const PAGE_SIZE = 20;

export const ROUTES = {
  HOME: "/",
  ADMIN: {
    ROOT: "/admin",
    LOGIN: "/admin/login",
    DASHBOARD: "/admin",
    RECORDS: "/admin/records",
    CONVERSATIONS: "/admin/conversations",
    DEBUG: "/admin/debug",
    USERS: "/admin/users",
    SETTINGS: "/admin/settings",
  },
} as const;
